module.exports = __webpack_public_path__ + "static/hook_horror-896e5381b6b742047858f378211dd922.jpg";